(function () {
  var root = document.querySelector('[data-prog-live]');
  if (!root) return;
  var organizer = root.getAttribute('data-organizer-id');
  var limit = parseInt(root.getAttribute('data-limit'), 10) || 3;
  if (!organizer) return;

  var TZ = 'Europe/Paris';
  function parts(ts, opts) {
    var out = {};
    new Intl.DateTimeFormat('fr-FR', Object.assign({ timeZone: TZ }, opts)).formatToParts(new Date(ts * 1000))
      .forEach(function (p) { out[p.type] = p.value; });
    return out;
  }
  function hour(ts) {
    var p = parts(ts, { hour: 'numeric', minute: '2-digit', hourCycle: 'h23' });
    var h = String(parseInt(p.hour, 10));
    return h + 'H' + (p.minute !== '00' ? p.minute : '');
  }
  function el(tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text != null) e.textContent = text;
    return e;
  }
  function br(parent, a, b) {
    parent.appendChild(document.createTextNode(a));
    parent.appendChild(document.createElement('br'));
    parent.appendChild(document.createTextNode(b));
  }

  function row(ev) {
    var a = el('a', 'pp-program__row pp-program__row--live');
    a.setAttribute('data-prog-row', '');
    a.href = ev.permalink;
    a.target = '_blank';
    a.rel = 'noopener';

    var left = el('div', 'pp-program__left');
    var dm = el('p', 'pp-program__daymonth');
    var d = parts(ev.startTime, { weekday: 'short', month: 'short', day: 'numeric' });
    br(dm, d.weekday.replace('.', '').slice(0, 3).toUpperCase(), d.month.replace('.', '').slice(0, 4).toUpperCase());
    var num = el('p', 'pp-program__num', d.day);
    var hrs = el('p', 'pp-program__hours');
    br(hrs, hour(ev.startTime), hour(ev.endTime));
    left.appendChild(dm); left.appendChild(num); left.appendChild(hrs);

    var right = el('div', 'pp-program__right');
    right.setAttribute('data-prog-title', '');
    var name = String(ev.name || '');
    var cut = name.indexOf(' - ');
    var title = cut > -1 ? name.slice(0, cut) : name;
    var sub = cut > -1 ? name.slice(cut + 3) : (ev.tags || []).slice(0, 3).map(function (t) { return t.name; }).join(' · ');
    if (ev.isSoldOut) sub = (sub ? sub + ' — ' : '') + 'Complet';
    right.appendChild(el('p', 'pp-program__title', title));
    if (sub) right.appendChild(el('p', 'pp-program__sub', sub));

    a.appendChild(left); a.appendChild(right);
    return a;
  }

  fetch('https://shotgun.live/api/data/organizers/' + encodeURIComponent(organizer) + '/events-listing-widget')
    .then(function (r) { return r.ok ? r.json() : Promise.reject(r.status); })
    .then(function (data) {
      var now = Date.now() / 1000;
      var events = (data.events || [])
        .filter(function (e) { return e.endTime > now; })
        .sort(function (a, b) { return a.startTime - b.startTime; })
        .slice(0, limit);

      var holder = root.querySelector('[data-prog-rows]');
      if (!holder) return;
      holder.innerHTML = '';
      if (!events.length) {
        holder.appendChild(el('p', 'pp-program__empty', root.getAttribute('data-empty-text') || 'Pas d’événement annoncé pour le moment.'));
        var h = root.querySelector('.pp-h2');
        var eh = root.getAttribute('data-empty-heading');
        if (h && eh) h.textContent = eh;
        var mo = root.querySelector('.pp-program__month'); if (mo) mo.hidden = true;
        var nt = root.querySelector('.pp-program__note'); if (nt) nt.hidden = true;
        return;
      }
      events.forEach(function (e) { holder.appendChild(row(e)); });
      var m = parts(events[0].startTime, { month: 'long', year: 'numeric' });
      var label = root.querySelector('.pp-program__month');
      if (label) label.textContent = m.month.charAt(0).toUpperCase() + m.month.slice(1) + ' ' + m.year;
    })
    .catch(function () { /* keep the static rows as fallback */ });
})();
